import React, { FC, createRef } from 'react'
import { LessonType } from '../../types'
import { StyledLessonPreviewItem, PreviewLessonType } from '.'

type Props = {
  lesson: LessonType;
  index: number;
  setPreviewLesson: (lesson?: PreviewLessonType) => void;
}

const LessonPreviewItem: FC<Props> = ({ lesson, index, setPreviewLesson }) => {
  const thumbnailRef = createRef<HTMLDivElement>()

  const showLessonPreview = (lesson: LessonType) => {
    if (!thumbnailRef || !thumbnailRef.current) {
      return
    }

    // Need to collect positioning data for the preview modal
    const thumbnailDiv = thumbnailRef.current.getBoundingClientRect()
    const thumbnailHeight = thumbnailDiv.height
    const modalX = thumbnailDiv.left + thumbnailDiv.width
    const modalY = window.scrollY + thumbnailDiv.top + thumbnailHeight / 2

    setPreviewLesson({
      ...lesson,
      modalX,
      modalY
    })
  }

  const hideLessonPreview = () => {
    setPreviewLesson(undefined)
  }

  return (
    <StyledLessonPreviewItem
      onMouseEnter={() => showLessonPreview(lesson)}
      onMouseMove={() => showLessonPreview(lesson)}
      onMouseLeave={() => hideLessonPreview()}
      className="scroll-item"
    >
      <div ref={thumbnailRef} className="lesson-thumbnail">
        {lesson.thumbnail && <img src={lesson.thumbnail.fileHttpLink} alt="" />}
      </div>
      <span className="lesson-index">{lesson.label || 'Lesson'}</span>
      <span className="lesson-title">{lesson.title}</span>
      <span className="lesson-learn-more">LEARN MORE</span>
    </StyledLessonPreviewItem>
  )
}

export default LessonPreviewItem
